import type { Faq } from '../components/ui/FaqList';

/**
 * FAQPage JSON-LD. Google only honours it when every question/answer is also
 * visible on the page, so always build it from the list the page renders.
 */
export const buildFaqJsonLd = (faqs: Faq[]) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map(({ q, a }) => ({
    '@type': 'Question',
    name: q,
    acceptedAnswer: { '@type': 'Answer', text: a },
  })),
});
